// Should this pattern be used for dealing with props.children?
// Or would using the REact helpers be better?
// https://reactjs.org/docs/react-api.html#reactchildren

const Aux = (props) => props.children;

export default Aux;